<template>
<label class="checkbox-wrapper">
  <input type="checkbox" v-model="check">
  <span class="viewer"></span>
</label>
</template>

<script>
export default {
  name: 'LayoutCheckbox',
  props: {
    value: {
      type: Boolean,
      isRequire: true,
    },
  },
  watch: {
    check(value) {
      this.$emit('input', value);
    },
  },
  data() {
    return {
      check: this.value,
    };
  },
};
</script>

<style lang="scss" scoped>
.checkbox-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;

  .viewer {
    display: block;
    position: relative;
    top: 1px;

    width: 20px;
    height: 20px;

    box-sizing: border-box;
    margin-right: 30px;

    border: rgba(0, 0, 0, 0.2) 1px solid;
    border-radius: 2px;

    transition: all 0.2s ease-in-out;

    cursor: pointer;
  }

  input:checked + .viewer {
    background-color: #0fb8ad;
  }

  input {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/LayoutCheckbox.vue